/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // EU/CH MwSt.-Sätze (adaptiert aus dem bisherigen Tax-Code des Kunden)
  var euVat = {
    AT: { name: 'Österreich', rate: 20 },
    BE: { name: 'Belgien', rate: 20 },
    BG: { name: 'Bulgarien', rate: 20 },
    CY: { name: 'Zypern', rate: 19 },
    CZ: { name: 'Tschechien', rate: 21 },
    DE: { name: 'Deutschland', rate: 19 },
    DK: { name: 'Dänemark', rate: 25 },
    EE: { name: 'Estland', rate: 22 },
    ES: { name: 'Spanien', rate: 21 },
    FI: { name: 'Finnland', rate: 25.5 },
    FR: { name: 'Frankreich', rate: 20 },
    GR: { name: 'Griechenland', rate: 24 },
    HR: { name: 'Kroatien', rate: 25 },
    HU: { name: 'Ungarn', rate: 27 },
    IE: { name: 'Irland', rate: 23 },
    IT: { name: 'Italien', rate: 22 },
    LT: { name: 'Litauen', rate: 21 },
    LU: { name: 'Luxemburg', rate: 17 },
    LV: { name: 'Lettland', rate: 21 },
    MT: { name: 'Malta', rate: 18 },
    NL: { name: 'Niederlande', rate: 21 },
    PL: { name: 'Polen', rate: 23 },
    PT: { name: 'Portugal', rate: 23 },
    RO: { name: 'Rumänien', rate: 19 },
    SE: { name: 'Schweden', rate: 25 },
    SI: { name: 'Slowenien', rate: 22 },
    SK: { name: 'Slowakei', rate: 20 }
  };

  function formatMoney(cents, referenceFormatted) {
    var n = Math.round(parseInt(cents, 10) || 0);
    var sign = n < 0 ? '-' : '';
    var abs = Math.abs(n);
    var intPart = Math.floor(abs / 100);
    var fracPart = abs % 100;

    var decimalSep = ',';
    var thousandSep = '.';
    var fractionDigits = 2;
    var prefix = '';
    var suffix = ' €';

    if (referenceFormatted) {
      var ref = String(referenceFormatted);
      var m = ref.match(/-?\d[\d.,]*/);
      if (m) {
        var num = m[0];
        prefix = ref.slice(0, m.index);
        suffix = ref.slice((m.index || 0) + num.length);
        var lastComma = num.lastIndexOf(',');
        var lastDot = num.lastIndexOf('.');
        var decIdx = Math.max(lastComma, lastDot);
        if (decIdx >= 0) {
          decimalSep = num.charAt(decIdx);
          fractionDigits = num.length - decIdx - 1;
        } else {
          fractionDigits = 0;
        }
        var intSample = decIdx >= 0 ? num.slice(0, decIdx) : num;
        var sepMatch = intSample.match(/[\s.,](?=\d{3}(\D|$))/);
        if (sepMatch) thousandSep = sepMatch[0];
      }
    }

    var intStr = intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    var fracStr = fractionDigits > 0 ? (decimalSep + fracPart.toString().padStart(2, '0').slice(0, fractionDigits)) : '';
    return prefix + sign + intStr + fracStr + suffix;
  }

  // Deutscher Brutto → deutscher Netto (Basis für alle Länder)
  function calcNet(grossCents, rate) {
    return Math.round(grossCents * 100 / (100 + (rate || 19)));
  }

  // Deutscher Netto + MwSt. des Landes = Brutto-Anzeige im Besucherland (nur EU)
  function calcGrossFromNet(netCents, rate) {
    return Math.round(netCents * (100 + rate) / 100);
  }

  function getVisitorCountry() {
    try {
      var code = (sessionStorage.getItem('visitor_country') || 'DE').toUpperCase();
      if (code === 'CH') return { code: 'CH', name: 'Schweiz', rate: null };
      var c = euVat[code];
      if (c) return { code: code, name: c.name, rate: c.rate };
      return { code: code, name: 'Drittland', rate: null };
    } catch (e) {}
    return { code: 'DE', name: 'Deutschland', rate: 19 };
  }

  // Land kommt aus Shopify (localization.country), serverseitig ins <html data-visitor-country>
  // gerendert. Das ist die für den Checkout maßgebliche Quelle – kein externer Geo-IP-Dienst nötig.
  function detectCountry() {
    try {
      var code = (document.documentElement.getAttribute('data-visitor-country') || '').toUpperCase();
      if (code) sessionStorage.setItem('visitor_country', code);
    } catch (e) {}
    return Promise.resolve();
  }

  function getStoredPriceMode() {
    try {
      var stored = window.localStorage.getItem('priceMode');
      if (stored === 'gross' || stored === 'net') return stored;
    } catch (e) {}
    return 'net';
  }

  // Theme-Setting „Netto/Brutto-Umschalter aktivieren“. Ist er aus, macht das
  // gesamte Preis-Umschalt-JS nichts – die serverseitig gerenderten Bruttopreise
  // bleiben unangetastet und es gibt keinen Umschalter.
  function vatSwitchEnabled() {
    return document.documentElement.getAttribute('data-vat-switch-enabled') === 'true';
  }

  function applyPriceModeToAll() {
    if (!vatSwitchEnabled()) return;
    var mode = getStoredPriceMode();
    var country = getVisitorCountry();
    var containers = document.querySelectorAll('[data-price-net][data-price-gross]');

    containers.forEach(function(container) {
      var grossCents = container.getAttribute('data-price-gross-cents');
      var netVal = container.getAttribute('data-price-net');
      var grossVal = container.getAttribute('data-price-gross');
      var value; var compareVal;

      var baseGross = grossCents ? parseInt(grossCents, 10) : null;
      var baseCompare = container.getAttribute('data-compare-at-gross-cents');
      baseCompare = baseCompare ? parseInt(baseCompare, 10) : null;

      if (baseGross != null) {
        var isNoTaxCountry = country.code === 'CH' || country.rate == null;
        var netRate = isNoTaxCountry ? 0 : country.rate;
        if (isNoTaxCountry) {
          // Für steuerfreie Länder: keinen weiteren Steuerabzug durchführen.
          // Direkt den Marktpreis anzeigen (dieser ist dort bereits ohne MwSt.-Aufschlag).
          value = grossVal || formatMoney(baseGross, grossVal || netVal);
          if (baseCompare != null) {
            compareVal = container.getAttribute('data-compare-at-gross') || formatMoney(baseCompare, container.getAttribute('data-compare-at-gross') || grossVal);
          }
        } else {
          var germanNetCents = calcNet(baseGross, netRate);
          if (mode === 'net') {
            value = formatMoney(germanNetCents, netVal || grossVal);
          } else {
            value = formatMoney(calcGrossFromNet(germanNetCents, country.rate), grossVal || netVal);
          }
          if (baseCompare != null) {
            var germanCompareNetCents = calcNet(baseCompare, netRate);
            if (mode === 'net') {
              compareVal = formatMoney(germanCompareNetCents, container.getAttribute('data-compare-at-net') || netVal);
            } else {
              compareVal = formatMoney(calcGrossFromNet(germanCompareNetCents, country.rate), container.getAttribute('data-compare-at-gross') || grossVal);
            }
          }
        }
      } else {
        value = mode === 'gross' ? grossVal : netVal;
        if (value && container.getAttribute('data-compare-at-gross'))
          compareVal = mode === 'gross' ? container.getAttribute('data-compare-at-gross') : container.getAttribute('data-compare-at-net');
      }

      if (!value) return;

      // Struktur von price.liquid (PDP, Snippets mit render 'price')
      var priceContainer = container.querySelector(':scope > .price__container');
      if (priceContainer) {
        var regularEl = container.querySelector('.price__regular .price-item--regular');
        var saleEl = container.querySelector('.price__sale .price-item--sale');
        if (regularEl) regularEl.textContent = value;
        if (saleEl) saleEl.textContent = value;
        if (compareVal) {
          var compareEl = container.querySelector('.price__sale .price-item--regular');
          if (compareEl) compareEl.textContent = compareVal;
        }
        var badgeSpan = container.querySelector('[data-price-off-badge] [data-savings-value]');
        if (badgeSpan && (baseGross != null || grossCents)) {
          var badgeType = container.getAttribute('data-sale-badge-type');
          var g = baseGross != null ? baseGross : parseInt(container.getAttribute('data-price-gross-cents'), 10);
          var cg = baseCompare != null ? baseCompare : (container.getAttribute('data-compare-at-gross-cents') ? parseInt(container.getAttribute('data-compare-at-gross-cents'), 10) : null);
          if (cg != null) {
            var netRate = (country.code === 'CH' || country.rate == null) ? 0 : country.rate;
            var netG = netRate ? calcNet(g, netRate) : g;
            var netCg = netRate ? calcNet(cg, netRate) : cg;
            if (badgeType === 'percentage') {
              var pct = netCg ? Math.round((netCg - netG) * 100 / netCg) : 0;
              badgeSpan.textContent = pct + '%';
            } else {
              badgeSpan.textContent = formatMoney(netCg - netG, netVal || grossVal);
            }
          } else if (badgeType) {
            var pct = mode === 'gross' ? container.getAttribute('data-savings-pct-gross') : container.getAttribute('data-savings-pct-net');
            var amt = mode === 'gross' ? container.getAttribute('data-savings-amount-gross') : container.getAttribute('data-savings-amount-net');
            if (pct != null) badgeSpan.textContent = pct + '%';
            else if (amt != null) badgeSpan.textContent = amt;
          }
        }
        var wrap = container.closest('.product__price__wrap');
        if (wrap) {
          var taxNotice = wrap.querySelector('[data-product-tax-notice]');
          if (taxNotice) {
            var taxText = taxNotice.querySelector('[data-product-tax-notice-text]');
            if (taxText) {
              var inklStr = (country.code === 'CH' || country.rate == null)
                ? '(Nettopreis – keine Mehrwertsteuer zzgl. Verzollung)'
                : '(inkl. ' + country.rate + '% MwSt. (' + country.name + '))';
              var exklStr = (country.code === 'CH' || country.rate == null)
                ? '(Nettopreis – keine Mehrwertsteuer zzgl. Verzollung)'
                : '(exkl. ' + country.rate + '% MwSt. (' + country.name + '))';
              taxText.textContent = mode === 'gross' ? inklStr : exklStr;
            }
          }
        }
        return;
      }

      // Struktur von product-grid-price / product-column-item (.new-price / .old-price)
      var newPriceEl = container.querySelector('.new-price');
      if (newPriceEl) {
        var fromSmall = newPriceEl.querySelector('small');
        var prefix = fromSmall ? fromSmall.outerHTML + ' ' : '';
        newPriceEl.innerHTML = prefix + value;
        var oldPriceEl = container.querySelector('.old-price');
        if (oldPriceEl && compareVal) oldPriceEl.textContent = compareVal;
      }
    });

    // Toggle-Buttons (PDP + Cart), Warenkorb-Preise und Warenkorb-Hinweis nachziehen
    updateToggleButtons(mode, country);
    applyCartPriceMode(mode, country);
    applyCartNote(mode, country);
  }

  // Alle Netto/Brutto-Umschalter (PDP + Cart) auf den aktuellen Modus setzen
  function updateToggleButtons(mode, country) {
    var label = (mode === 'gross' && country && country.rate != null)
      ? (country.rate + '%')
      : '0%';
    document.querySelectorAll('[data-price-toggle-button], [data-cart-price-toggle-button]').forEach(function(btn) {
      btn.setAttribute('data-price-mode', mode);
      btn.classList.toggle('is-gross', mode === 'gross');
      var lbl = btn.querySelector('[data-price-toggle-label]');
      if (lbl) lbl.textContent = label;
    });
  }

  // Warenkorb-Preise (Cart-Seite + Drawer) an den gewählten Modus anpassen.
  // Basis ist immer der von Shopify gelieferte Brutto-Wert in Cent (data-gross-cents);
  // der ursprüngliche Brutto-Text wird beim ersten Lauf in data-gross-text gesichert.
  function applyCartPriceMode(mode, country) {
    var noTax = !country || country.code === 'CH' || country.rate == null || !country.rate;
    document.querySelectorAll('[data-cart-price][data-gross-cents]').forEach(function(el) {
      var cents = parseInt(el.getAttribute('data-gross-cents'), 10);
      if (isNaN(cents)) return;
      var grossText = el.getAttribute('data-gross-text');
      if (grossText == null) {
        grossText = el.textContent.trim();
        el.setAttribute('data-gross-text', grossText);
      }
      if (mode === 'net' && !noTax) {
        el.textContent = formatMoney(calcNet(cents, country.rate), grossText);
      } else {
        el.textContent = grossText;
      }
    });

    // Label-Zusatz der Gesamtsumme („(netto)“ / „(brutto)“)
    document.querySelectorAll('[data-cart-total-label-tax]').forEach(function(el) {
      el.textContent = (mode === 'net' && !noTax) ? '(netto)' : '(brutto)';
    });
  }

  // Hinweistext im Warenkorb je nach Modus (klärt, dass der Checkout brutto berechnet)
  function applyCartNote(mode, country) {
    var noTax = !country || country.code === 'CH' || country.rate == null || !country.rate;
    var text;
    if (noTax) {
      text = 'Nettopreise – keine Mehrwertsteuer, zzgl. Verzollung.';
    } else if (mode === 'net') {
      text = 'Preise netto (zzgl. ' + country.rate + '% MwSt.). Im Checkout wird der Bruttobetrag inkl. MwSt. berechnet.';
    } else {
      text = 'Preise brutto (inkl. ' + country.rate + '% MwSt.).';
    }
    document.querySelectorAll('[data-cart-mode-note]').forEach(function(el) {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  // Switch bei Schweiz/Drittländern (ohne MwSt.) ausblenden – dort gibt es nur Nettopreis
  function applyVatSwitchVisibility() {
    var country = getVisitorCountry();
    var hide = country.code === 'CH' || country.rate == null;
    document.querySelectorAll('.product__price__wrap').forEach(function(wrap) {
      if (hide) wrap.classList.add('product__price__wrap--no-vat-switch');
      else wrap.classList.remove('product__price__wrap--no-vat-switch');
    });
    // Cart-Umschalter (Cart-Seite + Drawer) bei steuerfreien Ländern ausblenden
    document.body.classList.toggle('cart--no-vat-switch', hide);
  }

  // MwSt.-Hinweis (vat-info-text auf PDP): landabhängig inkl./exkl.; Drittländer/CH nur Netto-Hinweis
  function applyVatNoticeMode() {
    if (!vatSwitchEnabled()) return;
    var el = document.getElementById('vat-info-text');
    if (!el) return;
    var mode = getStoredPriceMode();
    var country = getVisitorCountry();
    var label;
    if (country.code === 'CH' || country.rate == null) {
      label = '(Nettopreis – keine Mehrwertsteuer zzgl. Verzollung)';
    } else {
      label = mode === 'gross'
        ? '(inkl. ' + country.rate + '% MwSt. (' + country.name + '))'
        : '(exkl. ' + country.rate + '% MwSt. (' + country.name + '))';
    }
    if (el.textContent.trim() === label) return;
    el.textContent = label;
  }

  function initVatNoticeObserver() {
    var el = document.getElementById('vat-info-text');
    if (!el) return;
    applyVatNoticeMode();
    var obs = new MutationObserver(function() {
      applyVatNoticeMode();
    });
    obs.observe(el, { childList: true, characterData: true, subtree: true });
  }

  window.applyPriceModeToAll = applyPriceModeToAll;
  window.applyVatNoticeMode = applyVatNoticeMode;
  window.getVisitorCountry = getVisitorCountry;
  window.pmgwFormatMoney = formatMoney;
  window.pmgwCalcNet = calcNet;
  window.pmgwCalcGrossFromNet = calcGrossFromNet;

  function syncCountryFromTheme() {
    var inp = document.querySelector('input[name="country_code"]');
    if (inp && inp.value) {
      try {
        var code = inp.value.toUpperCase();
        if (code) sessionStorage.setItem('visitor_country', code);
      } catch (e) {}
    }
  }

  // Manche Produkt-Templates (Vermietung/Miete/Trotec …) haben noch einen eigenen
  // Kunden-Block für die Netto-Anzeige (#vat-info-text / #vat-info-block / .vat-info).
  // Dort den theme-eigenen Hinweis ausblenden, damit die Zeile nicht doppelt erscheint.
  // Läuft unabhängig vom Switch-Setting.
  function dedupeVatNote() {
    var hasCustom = document.getElementById('vat-info-text')
      || document.getElementById('vat-info-block')
      || document.querySelector('.vat-info');
    if (!hasCustom) return;
    document.querySelectorAll('[data-product-tax-notice]').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  // Formatierten Geldbetrag (z. B. "3.499,99 €") zurück in Cent umwandeln.
  function parseMoneyToCents(text) {
    if (!text) return null;
    var s = String(text).replace(/[^\d.,]/g, '');
    if (!s) return null;
    var dec = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    var intPart, fracPart;
    if (dec >= 0 && (s.length - dec - 1) <= 2) {
      intPart = s.slice(0, dec).replace(/[.,]/g, '');
      fracPart = (s.slice(dec + 1) + '00').slice(0, 2);
    } else {
      intPart = s.replace(/[.,]/g, '');
      fracPart = '00';
    }
    var cents = parseInt(intPart || '0', 10) * 100 + parseInt(fracPart, 10);
    return isNaN(cents) ? null : cents;
  }

  // Netto-Zeile (Switch-AUS: „(inkl. X% MwSt. (Land) | Nettopreis: …)") aus dem
  // aktuell ANGEZEIGTEN Bruttopreis neu berechnen. Nötig beim Variantenwechsel,
  // weil das Theme nur den sichtbaren Preis aktualisiert, nicht unseren Hinweis.
  function updateNetNoteInWrap(wrap) {
    var country = getVisitorCountry();
    if (!country || country.code === 'CH' || country.rate == null || !country.rate) return;
    var noteWrap = wrap.querySelector('[data-product-tax-notice]');
    if (!noteWrap) return;
    if (getComputedStyle(noteWrap).display === 'none') return; // Spezial-Templates: eigener Kunden-Block
    var textEl = noteWrap.querySelector('[data-product-tax-notice-text]');
    if (!textEl) return;
    var priceBlock = wrap.querySelector('[id^="Price-"] .price') || wrap.querySelector('.price');
    if (!priceBlock) return;
    var onSale = priceBlock.classList.contains('price--on-sale');
    var sellEl = onSale
      ? priceBlock.querySelector('.price__sale .price-item--sale')
      : priceBlock.querySelector('.price__regular .price-item--regular');
    if (!sellEl) sellEl = priceBlock.querySelector('.price-item--regular');
    var grossCents = parseMoneyToCents(sellEl && sellEl.textContent);
    if (grossCents == null) return;
    // Sauberes Format als Referenz (z. B. "3.749,99 €") statt des angezeigten Textes,
    // damit Zusätze wie "Ab" oder "/ Tag" nicht in den Nettowert geraten.
    var priceContainer = wrap.querySelector('[id^="Price-"]');
    var refFormat = (priceContainer && (priceContainer.getAttribute('data-price-gross') || priceContainer.getAttribute('data-price-net'))) || (sellEl && sellEl.textContent);
    var netStr = formatMoney(calcNet(grossCents, country.rate), refFormat);
    var desired = '(inkl. ' + country.rate + '% MwSt. (' + country.name + ') | Nettopreis: ' + netStr + ')';
    if (textEl.textContent.replace(/\s+/g, ' ').trim() !== desired) {
      textEl.textContent = desired;
    }
  }

  // Preisblock beobachten: sobald das Theme den Preis ändert (Variantenwechsel,
  // Section-Re-Render), die Netto-Zeile nachziehen. Nur im Switch-AUS-Modus;
  // im AN-Modus übernimmt die Umschalt-Logik. Idempotenter Write => keine Endlosschleife.
  function setupVariantNoteSync() {
    document.querySelectorAll('.product__price__wrap').forEach(function(wrap) {
      if (wrap.__vatNoteSynced) return;
      wrap.__vatNoteSynced = true;
      updateNetNoteInWrap(wrap);
      var obs = new MutationObserver(function() {
        if (vatSwitchEnabled()) return;
        updateNetNoteInWrap(wrap);
      });
      obs.observe(wrap, { subtree: true, childList: true, characterData: true });
    });
  }

  function initPriceAndVat() {
    syncCountryFromTheme();
    dedupeVatNote();
    detectCountry().then(function() {
      applyPriceModeToAll();
      applyVatSwitchVisibility();
      setTimeout(initVatNoticeObserver, 300);
      setTimeout(dedupeVatNote, 400);
      setupVariantNoteSync();
    });
  }

  function reapplyPriceUi() {
    if (!vatSwitchEnabled()) return;
    applyPriceModeToAll();
    applyVatNoticeMode();
    applyVatSwitchVisibility();
  }

  function setStoredPriceMode(mode) {
    try { window.localStorage.setItem('priceMode', mode); } catch (e) {}
  }

  // Globaler Umschalter (PDP + Cart + Drawer): ein Klick auf einen der Switches
  // schaltet netto⇄brutto für die gesamte Seite. Der frühere PDP-Inline-Handler
  // wurde entfernt, damit sich beide nicht gegenseitig aufheben.
  document.addEventListener('click', function(event) {
    var btn = event.target.closest('[data-price-toggle-button], [data-cart-price-toggle-button]');
    if (!btn) return;
    event.preventDefault();
    var mode = getStoredPriceMode() === 'net' ? 'gross' : 'net';
    setStoredPriceMode(mode);
    reapplyPriceUi();
  });

  // Nach AJAX-Cart-Updates (Menge ändern, entfernen, Drawer öffnen) werden
  // Line-Items/Summen neu gerendert – Preise & Hinweis erneut in den Modus bringen.
  document.addEventListener('theme:cart:change', function() {
    applyPriceModeToAll();
    setTimeout(applyPriceModeToAll, 60);
  });

  // Drawer öffnen / Cart-Refresh: falls der Inhalt vor einem Moduswechsel gerendert
  // wurde, beim Öffnen erneut in den aktuellen Modus bringen.
  document.addEventListener('theme:cart-drawer:open', function() {
    applyPriceModeToAll();
    setTimeout(applyPriceModeToAll, 60);
  });
  document.addEventListener('theme:cart:refresh', function() {
    setTimeout(applyPriceModeToAll, 60);
  });

  // Back-/Forward-Cache (bfcache): Safari/Chrome stellen die Seite beim Zurück/Vor
  // aus dem Cache wieder her, OHNE DOMContentLoaded – dann liefe der Init-Code nicht
  // und der Warenkorb zeigte den alten Modus. pageshow(persisted) fängt das ab.
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      syncCountryFromTheme();
      detectCountry().then(reapplyPriceUi);
    }
  });

  // Wenn der Nutzer im Header das Land wechselt (Localization-Formular), unseren
  // sessionStorage aktualisieren, damit MwSt.-Satz und -Text zum gewählten Land passen.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('localization') !== -1) {
      var inp = form.querySelector('input[name="country_code"]');
      if (inp && inp.value) {
        try {
          sessionStorage.setItem('visitor_country', inp.value.toUpperCase());
        } catch (err) {}
      }
    }
  }, true);

  // Variantenwechsel: Theme aktualisiert Preisblöcke asynchron, daher UI mehrfach nachziehen.
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (!target) return;
    if (!target.closest('variant-selects') && !target.closest('[data-product-options]')) return;
    reapplyPriceUi();
    setTimeout(reapplyPriceUi, 120);
    setTimeout(reapplyPriceUi, 320);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceAndVat);
  } else {
    initPriceAndVat();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
